<template>
  <div class="collapse-menu-container" v-click-outside="clickedOutside">
    <div
      :class="[
        'collapse-menu',
        {
          'is-active': isOpen,
        },
      ]"
    >
      <div class="collapse-menu__top">
        <div
          v-for="(item, index) of itemsTopMenu"
          v-show="item.id != currentItem.id"
          class="collapse-menu__item"
          :key="index"
          @click.prevent="onClick(item)"
        >
          <span v-html="item.title || item.name"></span>
        </div>
      </div>
      <div class="collapse-menu__middle">
        <button
          class="collapse-menu__item is-active"
          type="button"
          @click="toggleMenu(!isOpen)"
        >
          <i class="collapse-menu__icon-menu">
            <span></span>
          </i>
          <span
            class="collapse-menu__middle-text-content"
            v-html="currentItem.title || currentItem.name"
          />
          <span></span>
        </button>
      </div>
      <div class="collapse-menu__bottom">
        <div
          v-for="(item, index) of itemsBottomMenu"
          v-show="item.id != currentItem.id"
          class="collapse-menu__item"
          :key="index"
          @click="onClick(item)"
        >
          <span v-html="item.title || item.name"></span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { redirectTo } from '@javascript/utils/helper-methods'
export default {
  name: 'CollapseMenuV2',
  props: {
    items: {
      type: Array,
      default: [],
    },
    initialItem: {
      type: Object,
      default: null,
    },
  },
  data: () => ({
    isOpen: false,
    currentItem: null,
  }),
  computed: {
    itemsMenuMedian() {
      return Math.floor(this.items.length / 2)
    },
    itemsTopMenu() {
      return this.items.slice(0, this.itemsMenuMedian)
    },
    itemsBottomMenu() {
      return this.items.slice(this.itemsMenuMedian)
    },
  },
  methods: {
    toggleMenu(value) {
      this.isOpen = value
    },
    setCurrentItem(item) {
      this.currentItem = item
    },
    onClick(item) {
      this.toggleMenu(false)
      this.setCurrentItem(item)
      this.$emit('click', item)
    },
    clickedOutside() {
      this.toggleMenu(false)
    },
  },
  created() {
    this.currentItem = this.initialItem
  },
}
</script>
